import { render, staticRenderFns } from "./IndexInactiveCompany.vue?vue&type=template&id=96b97dfe&"
import script from "./IndexInactiveCompany.vue?vue&type=script&lang=js&"
export * from "./IndexInactiveCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports